export function injectNtrNofollow(html: string): string {
  if (!html.includes('/ntr-')) {
    return html
  }

  return html.replace(
    /<a\s+([^>]*href=["'][^"']*\/ntr-[^"']*["'][^>]*)>/gi,
    match => {
      if (/nofollow/i.test(match)) {
        return match
      }

      if (/rel\s*=/.test(match)) {
        return match.replace(/rel\s*=\s*["']([^"']*)["']/i, 'rel="$1 nofollow"')
      }
      return match.replace(/>$/, ' rel="nofollow">')
    }
  )
}

export const checkNTRUrl = (href: string): boolean => {
  return href.includes('/ntr-')
}
